import { useMemo } from 'react';
const useIconVariation = _ref => {
  let {
    size = 24,
    icons
  } = _ref;
  return useMemo(() => {
    if (icons._16 && size <= 16) {
      return icons._16;
    }
    return icons._24;
  }, [size, icons]);
};
export default useIconVariation;
//# sourceMappingURL=useIconVariation.js.map